import React from 'react';
import { LetterData } from '../../types/letter';
import {
    LetterClassicTemplate,
    LetterCorporateTemplate,
    LetterFormelTemplate,
    LetterIvoireTemplate,
    LetterModernTemplate,
} from './templates/LetterTemplates';

interface Props {
    data: LetterData;
    template?: string;
    showPlaceholders?: boolean;
}

const map: Record<string, React.FC<{ data: LetterData; showPlaceholders?: boolean }>> = {
    'letter-formel': LetterFormelTemplate,
    'letter-classic': LetterClassicTemplate,
    'letter-corporate': LetterCorporateTemplate,
    'letter-modern': LetterModernTemplate,
    'letter-ivoire': LetterIvoireTemplate,
};

const LetterPreview: React.FC<Props> = ({ data, template, showPlaceholders }) => {
    const id = template || data.template || 'letter-formel';
    const Comp = map[id] || LetterFormelTemplate;
    return <Comp data={data} showPlaceholders={showPlaceholders} />;
};

export default LetterPreview;
